import { heroSlider } from "./hero";
import { initBestsellersTabs } from "./bestsellers";
import { initManualReviews } from "./manual-reviews";
import { initIconFeatureRow } from "./icon-feature-row";

document.addEventListener('DOMContentLoaded', () => {
  heroSlider();
  initBestsellersTabs();
  initManualReviews();
  initIconFeatureRow();
});

document.addEventListener('shopify:section:load', (event) => {
  initBestsellersTabs(event.target);  
  initManualReviews(event.target);
  initIconFeatureRow(event.target);
});